export const SERIES_PRODUCT_APPROVAL_ORDER_REQUEST = "SERIES_PRODUCT_APPROVAL_ORDER_REQUEST";
export const SERIES_PRODUCT_APPROVAL_ORDER_SUCCESS = " SERIES_PRODUCT_APPROVAL_ORDER_SUCCESS";
export const SERIES_PRODUCT_APPROVAL_ORDER_FAILED = "SERIES_PRODUCT_APPROVAL_ORDER_FAILED";
